import { Checkbox } from 'antd';
import styled from 'styled-components';
import { Drawer } from 'antd';

export const Container = styled.div``;

export const SpanSelectAllAndDeselectAll = styled.span`
  position: relative;
  color: #f0f0f0;
  cursor: pointer;
  margin-right: 8px;
`;

export const SeparateSpans = styled.span`
  position: relative;
  color: #f0f0f0;
  margin-right: 8px;
`;

export const GroupSelectAndDeselect = styled.div`
  display: flex;
  align-items: center;
`;

export const CheckboxComponent = styled(Checkbox)`
  display: flex;
  flex-direction: row;

  label {
    font-size: 12px !important;
  }
  span {
    font-size: 12px !important;
  }
`;

export const CheckboxGroup = styled(Checkbox.Group)`
  display: flex;
  flex-direction: column;

  label {
    font-size: 12px !important;
  }
`;

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-content-wrapper {
    width: 280px !important;
  }

  .ant-drawer-header {
    background: #fff !important;
  }

  .ant-drawer-title {
    color: #000 !important;
    font-weight: 400;
    font-size: 14px;
  }

  .ant-drawer-close {
    color: black;
    border: 1px solid #d9d9d9;
    padding: 4px;
  }

  .ant-drawer-body {
    padding: 0 !important;
    background: #fff !important;
    overflow-y: auto;
  }

  .new-filter-pinned {
    padding: 16px;
    background: #fff !important;
    margin-top: 0 !important;
    padding-bottom: 60px;
  }

  .ant-input,
  .ant-input-group-addon,
  .ant-input-search-button {
    background-color: #fff !important;
  }

  .content-clean {
    position: fixed;
    bottom: 0;
    left: 0;
    border-top: 1px solid #f0f0f0;
    padding: 10px 16px;
    width: 280px;
  }
`;
